import React, {useState} from 'react';
import {makeStyles, Stepper, Step, StepLabel, Typography, Button} from '@material-ui/core/';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import ComponenteFormularioAgregarRegistroDeContacto from '../DatosSolicitudYProcesoDeContacto'
import ComponenteFormularioRechazarSolicitudRegistroDeContacto from '../RechazarSolicitudProcesoDeContacto'
import {useStyles} from './style';

const StepperFormProcesoRegistroDeContacto = (props) => {
    const classes = useStyles(),
        steps =  ['Proceso de Contacto', 'Rechazar Solicitud del TSE Virtual',],
        getStepContent = (step) => {
            switch (step) {
                case 0:                    
                    return <ComponenteFormularioAgregarRegistroDeContacto {...props}  open={props.open} handleClose={props.handleClose} actualizarTabla={props.actualizarTabla}
                        ObtenerTotalDeSolicitudesPendientesDeRealizar={props.ObtenerTotalDeSolicitudesPendientesDeRealizar}
                    />;
                case 1:
                    return <ComponenteFormularioRechazarSolicitudRegistroDeContacto {...props} open={props.open} handleClose={props.handleClose} actualizarTabla={props.actualizarTabla}
                        ObtenerTotalDeSolicitudesPendientesDeRealizar={props.ObtenerTotalDeSolicitudesPendientesDeRealizar}
                    />;
                default:
                    return 'Ocurrió un error, Vuelva a recargar la página por favor!';
            }
        };
        
    return (
        <div className={classes.root}>
            <Stepper className={classes.Margenes} activeStep={props.stepperProcesoRegistroDeContacto}>
                {steps.map((label, index) => {
                    const stepProps = {};
                    if(props.rechazarSolicitudProcesoRegistroDeContacto){
                        if (index === 0) {
                            stepProps.completed = false;
                        }
                    }
                    return (
                    <Step key={label} {...stepProps}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                    );
                })}
            </Stepper>
                {props.stepperProcesoRegistroDeContacto === steps.length ? (
                    ""
                ) : (
                    <div>
                        {getStepContent(props.stepperProcesoRegistroDeContacto)}
                    </div>
                )}
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(StepperFormProcesoRegistroDeContacto);